module.exports = __webpack_public_path__ + "img/thumb-005-20.97ddd33d.png";